import {Divider, Menu} from "antd";
import React, { useEffect } from 'react';
import { getResources, ReduxState, ResourceDefinition } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from "react-router-dom";
import { setViewMode } from "../../actions/uiActions";
import {
  faChartPie
} from '@fortawesome/free-solid-svg-icons';
import FaIcon from "../Icons/FaIcon";

const getViewModeOfResource = (currentResource: string, resources: ResourceDefinition[]) => {
  for (let resource of resources) {
    if (resource.name == currentResource) {
      return resource.options?.viewMode
    }
  }
  return null;
}

const renderResource = (resource: any) => {
  return (
    <Menu.Item key={resource.name}>
      <NavLink to={"/" + resource.name}>
        <span
          className="icon"
        >
          {resource.icon}
        </span>
        <span className="label" style={{ textTransform: 'capitalize' }}>{resource.options?.label || resource.name}</span>
      </NavLink>
    </Menu.Item>
  )
}
const SideNav = () => {
  const resources = useSelector(getResources);
  const dispatch = useDispatch();
  const viewMode = localStorage.getItem('pov_preference') || useSelector((state: ReduxState) => state.ui.viewMode);
  const currentPath = useSelector((state: ReduxState) => state.router.location.pathname);
  const user = JSON.parse(localStorage.getItem('user') as string);

  useEffect(() => {
    const currentResource: string = currentPath.replace(/[\/\\]/, '').split('/')[0];
    const resourceViewMode = getViewModeOfResource(currentResource, resources)
    if (resourceViewMode && resourceViewMode != viewMode && !(resourceViewMode === "SUPERUSER")) {
      dispatch(setViewMode(resourceViewMode));
    }
  }, [currentPath])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        <Menu theme="light" mode="inline">
          <Menu.Item key='dashboard'>
            <NavLink exact to='/'>
              <span className="icon">{FaIcon(faChartPie)}</span>
              <span className="label" style={{ textTransform: 'capitalize' }}>Dashboard</span>
            </NavLink>
          </Menu.Item>
          {
            resources.map(resource =>
            !resource.options?.belowFold &&
            (
                resource.options?.viewMode == viewMode || !resource.options?.viewMode) &&
                resource.options?.viewMode != false ?
                (renderResource(resource))
                :
                null
            )
          }
          <Divider />
          {
            resources.map(resource =>
            resource.options?.belowFold == true &&
            (resource.options?.viewMode == viewMode || !resource.options?.viewMode) &&
            resource.options?.viewMode != false ?
                (renderResource(resource))
                :
                null
            )
          }
          {
            user?.is_superuser &&
              <>
                <Divider />
                {resources.map((resource => resource.options?.viewMode==="SUPERUSER"?renderResource(resource):null))}
              </>
          }
        </Menu>
      </div>
    </div>
  )
}

export default SideNav;